import styled from "styled-components";

export const WxdhRuleStyle = styled.div`
@font-face {
  font-family: 'dingliesongtypeface';
  src: url('https://cdn-prd.ggac.com/ggac/font/dingliesongtypeface20241217.ttf');
}
@font-face {
    font-family: 'SourceHanSerifCN';
    src: url('https://cdn-prd.ggac.com/ggac/font/SourceHanSerifCN-Medium.otf');
}
.rule {
    background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-bg.jpg") center center no-repeat;
    background-size: 100% 100%;
    margin-top: -5px;
    padding: 80px 0 0;
    font-family: 'dingliesongtypeface';
    .title-wrap {
        .title {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 35px;
            position: relative;
            .title-word {
                font-size: 50px;
                span {
                    font-size: 60px;
                }
                div {
                    background: linear-gradient(180deg, #fefcfb 0%, #ffeba9 100%);
                    -webkit-background-clip: text;
                    background-clip: text;
                    color: transparent;
                    -webkit-text-fill-color: transparent;
                }
            }
            .left,.right {
                height: 22px;
            }
        }
        .num {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: -10px;
            width: 55px;
        }
        .en-word {
            font-size: 12px;
            letter-spacing: 18px;
            padding-left: 18px;
            color: #ffffff;
            opacity: 0.4;
            text-align: center;
            font-family: 'SourceHanSerifCN';
            margin-top: -10px;
        }
    }
    .part1 {
        margin-top: 50px;
        position: relative;
        &-content {
            background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-rule-part1-border.png") center center no-repeat;
            background-size: 100% 100%;
            width: 1200px;
            aspect-ratio: 1286 / 536;
            margin: 0 auto;
            padding: 55px 80px 0;
            text-align: center;
            .item {
                margin-bottom: 15px;
                font-size: 20px;
            }
            .name {
	            color: #ffe79a;
                position: relative;
                padding-bottom: 25px;
                &::after{
                    content: "";
                    background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-rule-part1-word-line.png") center center no-repeat;
                    background-size: 100% 100%;
                    width: 413px;
                    height: 13px;
                    position: absolute;
                    left: 50%;
                    transform: translateX(-50%);
                    bottom: 10px;
                }
            }
            .desc {
	            color: #fffffe;
            }
        }
        .icon1 {
            position: absolute;
            left: 0;
            bottom: -250px;
            width: 250px;
        }
        .icon2 {
            position: absolute;
            right: 0;
            width: 200px;
            bottom: -100px;
        }
    }

    .part2 {
        margin-top: 140px;
        position: relative;
        &-content {
            background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-rule-part2-border.png") center center no-repeat;
            background-size: 100% 100%;
            width: 1200px;
            aspect-ratio: 1220 / 2146;
            margin: 40px auto 0;
            padding: 80px 80px 80px 90px;
            .name {
                font-size: 20px;
	            color: #ffe79a;
                position: relative;
                &::after {
                    background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-rule-part2-title-icon.png") center center no-repeat;
                    background-size: 100% 100%;
                    content: "";
                    width: 16px;
                    height: 14px;
                    position: absolute;
                    left: -20px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
            .desc {
                font-size: 20px;
	            color: #fff;
            }
            .image {
                display: flex;
                justify-content: center;
                padding: 30px 0;
                gap: 30px;
                &-left {
                    display: flex;
                    flex-direction: column;
                    width: 623px;
                    .item {
                        margin: 10px 0 20px;
                        &:last-child {
                            margin-bottom: 0;
                        }
                        .img-name {
                            color: #fff;
                            font-size: 18px;
                            text-align: center;
                        }
                    }
                }
                &-right {
                    .item {
                        margin: 10px 0 0;
                        img {
                            height: 552px;
                        }
                        .img-name {
                            color: #fff;
                            font-size: 18px;
                            text-align: center;
                        }
                    }
                }
            }
            
        }
        .icon3 {
            position: absolute;
            right: 0;
            bottom: -170px;
            width: 250px;
        }
    }

    .part3 {
        margin-top: 140px;
        &-content {
            background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-rule-part3-border.png") center center no-repeat;
            background-size: 100% 100%;
            width: 1200px;
            aspect-ratio: 1286 / 428;
            margin: 50px auto 0;
            padding: 100px 130px;
            .item {
                display: flex;
                gap: 5px;
                margin-bottom: 30px;
                div {
                    font-size: 20px;
	                line-height: 25px;
	                color: #fff;
                }
            }
        }
    }

    .part4 {
        margin-top: 140px;
        position: relative;
        &-content {
            background: url("https://cdn-prd.ggac.com/ggac/submatch/wxdh/wxdh-rule-part4-border.png") center center no-repeat;
            background-size: 100% 100%;
            width: 1200px;
            aspect-ratio: 1220 / 646;
            margin: 50px auto 0;
            padding: 110px 130px;
            .item {
                display: flex;
                gap: 5px;
                margin-bottom: 30px;
                div {
                    font-size: 20px;
	                line-height: 25px;
	                color: #fff;
                }
            }
        }
        .icon4 {
            position: absolute;
            left: 0;
            top: 100px;
            width: 200px;
        }
    }

    .bottom {
        text-align: center;
        margin-top: 100px;
        .bottom-logo {
            width: 600px;
        }
        &-tree {
            display: flex;
            justify-content: space-between;
            width: 100%;
            img {
                width: 550px;
            }
        }
    }
}

`